/*
 * <tso-quick-view> — a drop-in variant of the theme's <quick-view> that loads a
 * dedicated drawer TEMPLATE instead of the shared ?view=modal one. This lets the
 * flavour-selector cards open a CREAM-styled drawer (?view=tso-modal) without
 * touching the site-wide quick-view.
 *
 * It subclasses the theme's registered `quick-view` element, so it inherits every
 * drawer animation, focus-trap and the cartUpdate→auto-close behaviour. The only
 * override is the fetched URL: `data-view` on the element (default "tso-modal")
 * selects which alternate product template renders the drawer body. That template's
 * section must output a `.quick-view__content` wrapper (same contract as the theme).
 */
(function () {
  function defineTsoQuickView() {
    var Base = window.customElements && customElements.get('quick-view');
    if (!Base) return false;                       // theme.js not ready yet
    if (customElements.get('tso-quick-view')) return true;

    class TsoQuickView extends Base {
      quickview() {
        var drawerContent = this.querySelector(this.selector);
        if (!drawerContent) return;
        var productUrl = (this.getAttribute('data-product-url') || '').split('?')[0];
        var view = this.getAttribute('data-view') || 'tso-modal-cream';
        var sectionUrl = productUrl + '?view=' + view;
        var self = this;

        fetch(sectionUrl)
          .then(function (response) { return response.text(); })
          .then(function (responseText) {
            setTimeout(function () {
              var parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
              var productElement = parsedHTML.querySelector(self.selector);
              if (!productElement) {
                console.error('[tso-quick-view] no', self.selector, 'in', sectionUrl,
                  '- is the', view, 'template assigned to a section that renders it?');
                return;
              }
              self.setInnerHTML(drawerContent, productElement.innerHTML);
              if (window.theme && theme.a11y) theme.a11y.trapFocus(self, self.focusElement);

              if (window.Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }

              document.dispatchEvent(new CustomEvent('quickview:loaded', {
                detail: { productUrl: self.getAttribute('data-product-url') }
              }));
            }, 200);
          })
          .catch(function (e) { console.error(e); });
      }
    }

    customElements.define('tso-quick-view', TsoQuickView);
    return true;
  }

  // theme.js is loaded before this file, so `quick-view` is normally already defined.
  // Guard anyway in case of async ordering: retry briefly until the base class exists.
  if (defineTsoQuickView()) return;
  document.addEventListener('DOMContentLoaded', defineTsoQuickView);
  var tries = 0;
  var poll = setInterval(function () {
    if (defineTsoQuickView() || ++tries > 60) clearInterval(poll);
  }, 50);
})();
